var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6025_906)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4999 118.65C84.3071 118.65 95.4999 107.681 95.4999 94.1499C95.4999 80.6189 84.3071 69.6499 70.4999 69.6499C56.6928 69.6499 45.4999 80.6189 45.4999 94.1499C45.4999 107.681 56.6928 118.65 70.4999 118.65Z",
    fill: "#FFDF00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4999 56.6499C73.4116 56.6499 85.4999 44.5616 85.4999 29.6499C85.4999 14.7382 73.4116 2.6499 58.4999 2.6499C43.5882 2.6499 31.4999 14.7382 31.4999 29.6499C31.4999 44.5616 43.5882 56.6499 58.4999 56.6499Z",
    fill: "#FF009D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9999 86.6499C98.1126 86.6499 105.5 79.2626 105.5 70.1499C105.5 61.0372 98.1126 53.6499 88.9999 53.6499C79.8872 53.6499 72.4999 61.0372 72.4999 70.1499C72.4999 79.2626 79.8872 86.6499 88.9999 86.6499Z",
    fill: "#00A5D5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6799 81.73C51.9936 81.73 54.6799 79.0437 54.6799 75.73C54.6799 72.4163 51.9936 69.73 48.6799 69.73C45.3662 69.73 42.6799 72.4163 42.6799 75.73C42.6799 79.0437 45.3662 81.73 48.6799 81.73Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4699 79L0.679932 121.73C0.679932 121.73 15.6799 94.83 0.679932 75.28L76.5199 0",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.47 81.0002L2.73999 123.79C2.73999 123.79 29.64 108.79 49.19 123.79L124.46 47.9502",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6799 14.73L109.06 91.47",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6025_906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.78,
    height: 123.79,
    fill: "white",
    transform: "translate(0.679932)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLogo2);
export default __webpack_public_path__ + "static/media/graphic-logo-2.c0b54624181afd228f8c5a9b58f4065f.svg";
export { ForwardRef as ReactComponent };